import React from 'react'
import classnames from 'classnames'
import styles from './index.module.less'
import Utils from '../../lib/utils'
const IMG_NAV_COUNT = 3 * 2
const NAV_COUNT = 10 * 2

function getLi (item0, item1, index) {
  let className = index < NAV_COUNT - 4 ? styles.nav : index < NAV_COUNT - 2 ? styles.i_last : styles.nav_hide
  return (
    <li key={`1_${index}`} className={className} >
      <a key='0' {...Utils.getATagProps(item0)} {...Utils.getItemSpmData(item0)}>{item0.title}</a>
      {
        item1 ? <a key='1' {...Utils.getATagProps(item1)} {...Utils.getItemSpmData(item1)}>{item1.title}</a> : ''
      }
    </li>
  )
}

function getImgLi (item0, item1, index) {
  const className = !item1 || index >= 4 ? '' : styles.i_nav
  return (
    <li key={`1_${index}`} className={className} >
      <a key='0' {...Utils.getATagProps(item0)} {...Utils.getItemSpmData(item0)}><img src={item0.img} />{item0.title}</a>
      {
        item1 ? <a key='1' {...Utils.getATagProps(item1)} {...Utils.getItemSpmData(item1)}><img src={item1.img} />{item1.title}</a> : ''
      }
    </li>
  )
}

// 左侧列表渲染
function renderLeftNavList (component) {
  const _len = component.itemList.length
  const itemListLeft = component.itemList.slice(0, IMG_NAV_COUNT)
  const itemListRight = component.itemList.slice(IMG_NAV_COUNT, _len)
  return (
    <ul className={styles.left} {...Utils.getComponentSpmData(component)}>
      {
        itemListLeft.map((object, index) => {
          if (index % 2 !== 0) {
            return ''
          }
          return index + 1 < itemListLeft.length ? getImgLi(object, itemListLeft[index + 1], index) : getImgLi(object, null, index)
        })
      }

      <li key={IMG_NAV_COUNT} className={`${styles.line}`} />

      {
        itemListRight.map((object, index) => {
          if (index % 2 !== 0) {
            return ''
          }
          return index + 1 < itemListRight.length ? getLi(object, itemListRight[index + 1], index) : getLi(object, null, index)
        })
      }
    </ul>)
}

// 右侧图标渲染
function renderRight (component) {
  return (
    <div className={styles.right} {...Utils.getComponentSpmData(component)}>
      {
        component.itemList.map((item, index) => {
          if (index > 2) {
            return ''
          }
          const itemClass = `it${index}`
          const className = classnames(styles.icon_item, styles[itemClass])
          return (
            <a key={index} href={item.link} target='_blank' className={className} {...Utils.getItemSpmData(item)}>
              <img src={item.img} />
              <span>{item.title}</span>
            </a>
          )
        })
      }
    </div>
  )
}
const NavIndex = (props) => {
  const length = props.data.components.length

  return (
    <div className={styles.main_nav}>
      {
        length > 0 ? renderLeftNavList(props.data.components[0]) : ''
      }
      {
        length > 1 ? renderRight(props.data.components[1]) : ''
      }
    </div>
  )
}
export default NavIndex
